import * as C from './styles';

type SkeletonVariant = 'page' | 'form' | 'table';

interface SkeletonProps {
  variant?: SkeletonVariant;
  rows?: number;
}

export function Skeleton({ variant = 'page', rows = 6 }: SkeletonProps) {
  if (variant === 'table') {
    return (
      <C.PageBlock>
        <C.Wrapper>
          <C.Row>
            <C.Bone $height='18px' $width='30%' />
            <C.Bone $height='18px' $width='20%' />
            <C.Bone $height='18px' $width='25%' />
            <C.Bone $height='18px' $width='15%' />
          </C.Row>
          {Array.from({ length: rows }).map((_, index) => (
            <C.Row key={index}>
              <C.Bone $height='40px' $width='30%' />
              <C.Bone $height='40px' $width='20%' />
              <C.Bone $height='40px' $width='25%' />
              <C.Bone $height='40px' $width='15%' />
            </C.Row>
          ))}
        </C.Wrapper>
      </C.PageBlock>
    );
  }

  if (variant === 'form') {
    return (
      <C.PageBlock>
        <C.Wrapper>
          <C.Bone $height='22px' $width='40%' />
          {Array.from({ length: rows }).map((_, index) => (
            <C.Bone key={index} $height='48px' $radius='8px' />
          ))}
          <C.Row>
            <C.Bone $height='44px' $width='140px' $radius='8px' />
            <C.Bone $height='44px' $width='140px' $radius='8px' />
          </C.Row>
        </C.Wrapper>
      </C.PageBlock>
    );
  }

  return (
    <C.PageBlock>
      <C.Wrapper>
        <C.Bone $height='28px' $width='45%' />
        <C.Bone $height='16px' $width='70%' />
        <C.Bone $height='160px' $radius='10px' />
        <C.Row>
          <C.Bone $height='48px' $width='48%' $radius='8px' />
          <C.Bone $height='48px' $width='48%' $radius='8px' />
        </C.Row>
        <C.Bone $height='48px' $radius='8px' />
        <C.Bone $height='48px' $radius='8px' />
      </C.Wrapper>
    </C.PageBlock>
  );
}
